export const CONTACT_METHOD_HAS_PHONE = ['phoneCall', 'whatsApp', 'zalo', 'sms'];

export const METHOD_LIST = [
  {label: 'WhatsApp', key: 'whatsApp', type: 'number'},
  {label: 'Messenger', key: 'messenger', type: 'text'},
  {label: 'Phone call', key: 'phoneCall', type: 'number'},
  {label: 'Email', key: 'email', type: 'text'},
  {label: 'Instagram', key: 'instagram', type: 'text'},
  {label: 'Telegram', key: 'telegram', type: 'text'},
  {label: 'Skype', key: 'skype', type: 'text'},
  {label: 'Line', key: 'line', type: 'text'},
  {label: 'Zalo', key: 'zalo', type: 'number'},
  {label: 'SMS', key: 'sms', type: 'number'},
  {label: 'TikTok', key: 'tiktok', type: 'text'}
];
